export default __webpack_public_path__ + "static/media/approved.cf76c624.svg";